<template>
  <div>
    <v-row class="justify-end">
      <v-col cols="12" md="8">
        <v-btn
          color="primary"
          title="เพิ่มผู้ประเมิน"
          outlined
          small
          @click="openDialogCreateAssessor"
        >
          <v-icon left>fa-plus</v-icon>
          เพิ่มผู้ประเมิน
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="assessorSearch"
          label="ค้นหา"
          solo
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :search="assessorSearch"
      :loading="assessorLoading"
      :headers="assessorHeaders"
      :items="assessors"
      :items-per-page="100"
      sort-by="id"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 75, 100, -1],
      }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          color="primary"
          class="mr-2"
          title="แก้ไขข้อมูล"
          small
          @click="editAssessor(item)"
        >
          fa-edit
        </v-icon>
        <v-icon
          color="danger"
          class="mr-2"
          title="ลบข้อมูล"
          small
          :disabled="item.can_delete"
          @click="deleteAssessor(item.id)"
        >
          fa-trash
        </v-icon>
      </template>
    </v-data-table>

    <DialogCreateAssessor :dialog.sync="dialogCreateAssessor" />
    <DialogEditAssessor :dialog.sync="dialogEditAssessor" :assessor="showAssessor" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { UPDATE_BREADCRUMBS, GET_ASSESSORS, DELETE_ASSESSOR } from "@/store/action.type"
import { CONFIRM_DELETE } from "@/common/consistent"
import { swalConfirm } from "@/common/alert"
import { DialogCreateAssessor, DialogEditAssessor } from "@/components/dialog/assessor"

export default {
  name: "OfficeAssessor",
  title: "จัดการผู้ประเมิน",
  components: {
    DialogCreateAssessor,
    DialogEditAssessor,
  },
  created() {
    this.$store.dispatch(UPDATE_BREADCRUMBS, [
      {
        text: "ผู้ประเมิน",
        disabled: false,
        exact: true,
        to: { name: "OfficeAssessor" },
      },
    ])
  },
  data() {
    return {
      assessorSearch: "",
      assessorHeaders: [
        { text: "ID", value: "id" },
        { text: "Username", value: "username" },
        { text: "ระยะเวลาใช้งาน", value: "available_date" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      showAssessor: {},
      dialogCreateAssessor: false,
      dialogEditAssessor: false,
    }
  },
  computed: {
    ...mapGetters(["assessors", "assessorLoading"]),
  },
  mounted() {
    this.getAssessor()
  },
  methods: {
    getAssessor() {
      this.$store.dispatch(GET_ASSESSORS)
    },
    openDialogCreateAssessor() {
      this.dialogCreateAssessor = true
    },
    editAssessor(assessor) {
      this.showAssessor = assessor
      this.dialogEditAssessor = true
    },
    deleteAssessor(facultyId) {
      swalConfirm("warning", CONFIRM_DELETE, () => {
        this.$store.dispatch(DELETE_ASSESSOR, facultyId)
      })
    },
  },
}
</script>
